<template>
  <Modal v-model="refundModal" width="800">
    <p slot="header" class="text-center">执行退款</p>
    <Form
      ref="refundInfo"
      :model="refundInfo"
      autocomplete="on"
      name="oohforce-device-add"
      id="oohforce-device-add"
      label-position="top"
    >
      <Row :gutter="8" class="m-b-10">
        <i-col span="8">
            <span class="title">订单实付金额 </span>{{ formatMoney(orderInfo.totalAmount) }}
        </i-col>
        <i-col span="8">
            <span class="title">退款手续费 </span>{{ formatMoney(orderInfo.serviceCharge) }}
        </i-col>
        <i-col span="8">
            <span class="title">实际退款金额 </span>{{ formatMoney(orderInfo.maxRefundFee) }}
        </i-col>
        <i-col span="24"  class="m-t-10">
          <FormItem label="退款说明">
            <Input
              v-model="refundInfo.remark"
              type="textarea"
              placeholder="退款说明"
            />
          </FormItem>
        </i-col>
        <i-col span="24"  class="m-t-10">
          <FormItem label="附件">
            <Upload
              ref="upload"
              :with-credentials="true"
              :action="action"
              :headers="uploadHeaders"
              :data="data"
              :show-upload-list="false"
              :format="format"
              :max-size="maxSize"
              :on-format-error="handleFormatError"
              :on-exceeded-size="handleExceedMaxsize"
              multiple
              :on-success="handleFileUploadSuccess"
              type="drag"
            >
              <div style="padding: 20px 0">
                <Icon
                  type="ios-cloud-upload"
                  size="52"
                  style="color: #3399ff"
                ></Icon>
                <p>点击或拖拽文件到这里进行上传</p>
              </div>
              <!-- <slot name="upload_btn">
        <div>
          <a >添加文件并上传</a>
        </div>
      </slot> -->
            </Upload>

            <div class="file-container">
              <div v-if="uploadFiles.length > 0">
                <h4 class="text-green p-t-10">最新上传文件</h4>
                <Row v-for="(file, i) in uploadFiles" :key="i">
                  <template v-if="file.status === 'finished'">
                    <i-col span="16">
                      {{ file.name }}
                    </i-col>
                    <i-col span="8">
                      <a
                        href="javascript:void(0)"
                        @click="handleDownload(file.response)"
                        >下载</a
                      >
                      <a
                        href="javascript:void(0)"
                        class="m-l-5"
                        style="color: #ef4f4f"
                        @click="handleRemove(file.response,i)"
                        >删除</a
                      >
                    </i-col>
                  </template>
                  <template v-else>
                    <i-col span="12">
                      <Progress
                        v-if="file.showProgress"
                        :percent="file.percentage"
                      ></Progress>
                      <span v-else>{{ file.name }}</span>
                    </i-col>
                    <!-- <i-col span="12">
                      <i-button
                        icon="ios-trash"
                        class="m-l-5"
                        type="error"
                        @click="handleRemove(file)"
                        >删除</i-button
                      >
                    </i-col> -->
                  </template>
                </Row>
              </div>
<!--
              <div v-if="existsFile.length > 0">
                <Divider dashed>已有文件</Divider>
                <i-table
                  stripe
                  :data="existsFile"
                  :columns="fileColumns"
                ></i-table>
              </div> -->
            </div>
            <!-- 上传描述，备注信息 -->
            <div class="tips m-l-10">
              <ul>
                <li>您只能上传后缀名为 {{ format.toString() }} 格式的文件</li>
                <li>文件大小不能超过 {{ maxSize / 1024 }} MB</li>
              </ul>
            </div>
          </FormItem>
        </i-col>
      </Row>
    </Form>

    <div slot="footer">
      <Button type="text" class="m-r-5" @click="refundModal = false"
        >关闭</Button
      >
      <Button type="primary" @click="handleConfirmPublicity"
      :loading="!allowSubmit">确定</Button>
    </div>
  </Modal>
</template>

<script>
import { downloadFileRequest } from '@/utils/download'

import { orderRefund } from '@/api/mediamall/order'
import { signurlByAttach, removeFileAttach } from '@/api/resource/endpoint'
import { getStorage } from '@/utils/storage'
import { toMoney } from '@/utils/wnumb_own'
export default {
  props: {
  },
  data () {
    return {
      orderInfo: {},

      refundModal: false,
      refundInfo: {
        orderNo: '',
        refundFee: '',
        attach: '',
        remark: ''
      },

      data: { code: 0 },
      uploadList: [],
      action: process.env.VUE_APP_API_URL_V2 + '/ooh-resource/oss/endpoint/put-file-attach',
      visible: false,
      uploadHeaders: {
        'ooh-auth': getStorage('ooh-token')
      },
      format: ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx', 'xls', 'xlsx'],
      maxSize: 204800,

      allowSubmit: true,
      uploadFiles: []

    }
  },
  mounted () {},
  methods: {

    formatMoney (number) {
      return toMoney(number)
    },
    showModal (orderInfo) {
      this.orderInfo = orderInfo
      this.uploadFiles = []
      this.refundInfo.remark = ''
      this.refundModal = true
    },

    hideModal () {
      this.refundModal = false
    },

    handleExceedMaxsize (file) {
      this.$Notice.warning({
        title: '已经超过了文件大小限制',
        desc: '文件  ' + file.name + ' 过大，不能超过' + this.maxSize + 'Kb'
      })
    },
    handleFormatError (file) {
      this.$Notice.warning({
        title: '文件类型不正确',
        desc: '文件  ' + file.name + ' 的类型只能是' + this.format.toString()
      })
    },
    handleFileUploadSuccess (response, file) {
      if (response.success) {
        this.uploadFiles.push(file)
      }
    },
    handleDownload (file) {
      signurlByAttach({ attachId: file.data.id }).then(res => {
        downloadFileRequest(res.data, { }, file.data.originalName)
      })
    },
    handleRemove (file, index) {
      this.uploadFiles.splice(index, 1)
      removeFileAttach({ attachId: file.data.id })
    },
    // 确定公示
    handleConfirmPublicity () {
      const that = this
      that.refundInfo.orderNo = that.orderInfo.orderNo
      that.refundInfo.refundFee = that.orderInfo.maxRefundFee

      if (that.uploadFiles.length) {
        that.refundInfo.attach = JSON.stringify(that.uploadFiles.map(file => {
          return { fileName: file.response.data.originalName, id: file.response.data.id }
        }))
      }
      this.allowSubmit = false
      orderRefund(that.refundInfo).then(res => {
        if (res && res.errcode === 0) {
          this.$Notice.success({ desc: '操作成功' })
          that.hideModal()
          this.$emit('on-success')
        }

        this.allowSubmit = true
      })
    }
  },
  watch: {},
  computed: {
  }
}
</script>
